import personalizeService from '../utils/rbmc.personalizeService';
import logger from '../utils/rbmc.logger';

const cartCounter = {
    initCounter() {
        personalizeService.getPersonalizedData().then((data) => {
                if (data.hasCart) {
                    this.updateCounter(data.totalUnitCount);
                }
            }, (jqXHR) => {
                logger.error(`error in cartCounter, code: ${jqXHR.status}`);
            }
        );
    },
    updateCounter(value) {
        $('#js-badge-pill').text(value > 9 ? '9+' : value).show();
    }
};

(() => {
    cartCounter.initCounter();
})();

export default cartCounter;
